import React from "react";
import { Title, ValueLabel } from "../../atoms";
import T from "prop-types";

export const ValueBox = ({ className, text, value }) => {
  return (
    <div className={className}>
      <Title className="boxTitle" text={text} />
      <ValueLabel value={value} />
    </div>
  );
};

ValueBox.T = {
  className: T.string,
  text: T.string,
  value: T.string,
  valueLabelCls: T.string,
};
ValueBox.defaultProps = {
  className: "boxLayer",
  valueLabelCls: "valueBoxC",
};
